export default function Configure($stateProvider) {
    $stateProvider.state('auditeurs', {
        parent: 'common',
        url: '/auditeurs',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('auditeurs.list', {
        url: '/:genre/list',
        template: '<sites></sites>',
        rights: { domain: 'siteaudit', right: 'read', application: 'qse' },
        ncyBreadcrumb: {
            label: '{{ "SITES.BREADCRUMBS.SITES_AUDITEURS_LIST" | translate}}'
        }
    });

    $stateProvider.state('auditeurs.niveaux', {
        url: '/:genre/niveaux',
        template: '<site-config-niveaux></site-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher sites > niveaux
            parent: 'auditeurs.list({genre: "auditeurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('auditeurs.list.detail', {
        url: '/:genre/{id}',
        template: '<site-detail></site-detail>',
        ncyBreadcrumb: {
            parent: 'auditeurs.list({genre: "auditeurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('auditeurs.new', {
        url: '/:genre/new',
        template: '<site-form></site-form>',
        rights: { domain: 'siteaudit', right: 'create' },
        ncyBreadcrumb: {
            parent: 'auditeurs.list({genre: "auditeurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NEW_AUDITEUR" | translate}}'
        },
        search: 'SITES.BREADCRUMBS.SITE_NEW_AUDITEUR'
    });

    $stateProvider.state('auditeurs.edit', {
        url: '/:genre/{id}/edit',
        template: '<site-form></site-form>',
        rights: { domain: 'siteaudit', right: 'update' },
        ncyBreadcrumb: {
            parent: 'auditeurs.list({genre: "auditeurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_EDIT_AUDITEUR" | translate }}'
        }
    });

    $stateProvider.state('auditeurs.feries', {
        url: '/:genre/{id}/feries',
        template: '<site-jours-feries></site-jours-feries>',
        rights: { domain: 'jferies', right: 'create' },
        ncyBreadcrumb: {
            parent: 'auditeurs.list({genre: "auditeurs"})',
            label: '{{ "SITES.BREADCRUMBS.JOURS_FERIES" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
